import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileModel } from '@ca/core/models';
import { FilePreviewService, UserService, WindowRef } from '@ca/core/services';
import { ArivisService } from 'src/app/core/services/arivis.service';
import * as FileUtils from '../../../../utils/file/file-utils';
import * as UrlUtils from '../../../../utils/url/url-utils';

@Component({
    selector: 'ca-file-selection-item',
    templateUrl: './file-selection-item.component.html',
    styleUrls: ['./file-selection-item.component.scss'],
})
export class FileSelectionItemComponent implements OnInit {
    @Input() file: FileModel;
    @Input() isDisabled: boolean;
    @Input() showViewIcon = true;
    @Input() showFileSize = true;
    @Input() filesSelectable = false;
    @Input() selected = false;
    @Output() onRemoveSelection = new EventEmitter<FileModel>();
    @Output() onClick = new EventEmitter<boolean>();
    @Output() onEditUrl = new EventEmitter<string>();
    @ViewChild('filePreview') filePreviewElement: ElementRef;
    viewerUrl: string;

    constructor(
        private filePreviewService: FilePreviewService,
        private arivisService: ArivisService,
        private userService: UserService,
        private windowRef: WindowRef,
    ) {}

    ngOnInit(): void {
        if (!this.file.viewerUrl) {
            if (!this.file.id) {
                this.viewerUrl = this.arivisService.generateArivisViewerUrl(this.file.token);
            } else {
                this.viewerUrl = this.arivisService.generateArivisMlViewerUrl(this.file);
            }
        } else {
            this.viewerUrl = this.file.viewerUrl;
        }
    }

    get isLoggedIn(): boolean {
        return this.userService.isLoggedIn;
    }

    isHttpOrHttpsUrl(url: string): boolean {
        return UrlUtils.isHttpOrHttpsUrl(url);
    }

    remove(file?: FileModel): void {
        if (file != null) {
            this.onRemoveSelection.emit(file);
        }
    }

    isFilePreviewSupportedByArivis(): boolean {
        return this.arivisService.isFilePreviewSupportedByArivis(this.file);
    }

    isSupportedByFilePreviewer(): boolean {
        if (this.file.storageType === 'Web') {
            return false;
        }

        return this.arivisService.isSupportedByFilePreviewer(this.file.type);
    }

    /**
     * Preview File previewer output.
     * You can define if it should be previewed in a modal, or as inline content.
     * For inline Content put <ca-file-previewer> (without any parameters) in the DOM where
     * the file should be shown.
     */
    previewOutput(openContentIn?: 'modal' | 'inline' | 'newTab'): void {
        if (this.isSupportedByFilePreviewer()) {
            // Necessary due to https://github.com/ng-bootstrap/ng-bootstrap/issues/1604#issuecomment-359425286
            if (this.filePreviewElement != null && this.filePreviewElement.nativeElement != null) {
                this.filePreviewElement.nativeElement.ownerDocument.activeElement.blur();
            }

            if (this.file && this.file.token) {
                this.filePreviewService.openWithURL(this.file.token, FileUtils.getFileExtension(this.file.token), openContentIn);
            }
        }
    }

    openViewer(): void {
        this.windowRef.nativeWindow.open(this.viewerUrl, '_blank');
    }

    editUrl(): void {
        this.onEditUrl.emit(this.file.url);
    }
}
